import React, { useState } from "react";
import { useEffect } from "react";
import { FiEdit } from "react-icons/fi";
import { MdDeleteForever } from "react-icons/md";
import styled from "styled-components";
import { useGetTemplateTextTable } from "../../../../hooks/useContent";
import Button from "../../../Button/Button";
import Loading from "../../../Loadings/LoadingTable";
import { Table } from "../../../Table/Table";
import { RenderTooltip } from "../../../Tooltip/Tooltip";
import { ButtonContainer } from "../Occations/OccationTable";
import DeleteTableText from "../../../Dialog/contentUnit/productCategory/DeleteTableText";
import EditTableText from "../../../Dialog/contentUnit/productCategory/EditTableText";

function TextTemplateTable({ refresh, setRefresh }) {
  const { data, isLoading, isError, refetch } = useGetTemplateTextTable();

  const [show, setShow] = useState({
    delete: false,
    update: false,
  });

  const [currentItem, setCurrentItem] = useState({});

  useEffect(() => {
    refetch();
  }, [refresh]);

  const handleUpdate = (item) => {
    setShow({ ...show, update: true });
    setCurrentItem(item);
  };

  const handleDelete = (item) => {
    setShow({ ...show, delete: true });
    setCurrentItem(item);
  };

  const items = data ? (
    data?.data?.Templates?.map((item, index) => {
      return (
        <tr key={index}>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {index + 1}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item?.NameTemplate ? item?.NameTemplate : ""}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item?.ContentTemplate ? item?.ContentTemplate : ""}
            </span>
          </td>
          <td>
            <ButtonContainer>
              <RenderTooltip title={"حذف جدول"}>
                <Button
                  size="12px"
                  bgColor="#C82333"
                  small="40px"
                  color="#fff"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onclick={(e) => {
                    handleDelete(item);
                  }}
                >
                  <MdDeleteForever size={25} />
                </Button>
              </RenderTooltip>
              <RenderTooltip title={"ویرایش جدول"}>
                <Button
                  size="12px"
                  bgColor="#0D6EFD"
                  small="40px"
                  color="#fff"
                  onclick={(e) => {
                    handleUpdate(item);
                  }}
                >
                  <FiEdit size={20} />
                </Button>
              </RenderTooltip>
            </ButtonContainer>
          </td>
        </tr>
      );
    })
  ) : (
    <Loading />
  );

  const pageCount = 0;

  const headerTitle = ["#", "نام", "محتوا", "عملیات"];

  return (
    <TemplateTableStyle>
      {" "}
      <Table
        noSearch={true}
        headerTitle={headerTitle}
        title={`جدول کلماتی که تاکنون ثبت شده اند`}
        items={items}
      />
      <DeleteTableText
        setRefresh={setRefresh}
        show={show?.delete}
        handleClose={() => {
          setShow({ ...show, delete: false });
        }}
        item={currentItem}
      />
      <EditTableText
        setRefresh={setRefresh}
        show={show?.update}
        handleClose={() => {
          setShow({ ...show, update: false });
        }}
        item={currentItem}
      />
    </TemplateTableStyle>
  );
}

const TemplateTableStyle = styled.div`
  margin-top: 2rem;
`;

export default TextTemplateTable;
